import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Layout from './views/Layout.vue';
import store from './store/index.js'
import router from './router'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)


Vue.use(ElementUI);

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(Layout)
});
